<div class="tableComponent row">
    <div class="col-lg-12">
        <app-table *ngIf="table" tableTitle="{{ 'projects.export.templates' | translate }} : {{ table.length }} {{ (table.length > 1 ? 'general.results' : 'general.result') | translate }}" [table]="table" [columns]="columns" [actions]="actions" (action)="onActionClick($event)"></app-table>
    </div>
</div>
